import { cva } from 'class-variance-authority';

/**
 * Dropzone コンポーネントのスタイルバリアント
 *
 * ドラッグ＆ドロップの状態に応じたスタイルを定義
 */
export const dropzoneVariants = cva(
  // ベーススタイル
  [
    'flex flex-col items-center justify-center',
    'rounded-lg border-2 border-dashed',
    'p-8 transition-colors',
    'cursor-pointer',
    'focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2',
  ],
  {
    variants: {
      state: {
        default: ['border-stone-300 bg-white', 'hover:border-brand-400 hover:bg-brand-50/50'],
        active: ['border-brand-500 bg-brand-50'],
        rejected: ['border-red-400 bg-red-50'],
        disabled: ['border-stone-200 bg-stone-50', 'cursor-not-allowed opacity-60'],
      },
    },
    defaultVariants: {
      state: 'default',
    },
  },
);
